import {
  DEFAULT_DIALOG_WIDTH,
  EntityIdAliasPrefixes,
} from '@abb-procure/constants';
import { InvitedUserModel, UserModel } from '@abb-procure/data';
import { Overlay } from '@angular/cdk/overlay';
import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  type InvitedUsersDialog,
  InvitedUsersDialogData,
} from '../components/invited-users-dialog/invited-users-dialog.component';
import {
  type ShareDialog,
  ShareDialogData,
  ShareDialogType,
} from '../components/share-dialog/share-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ShareDialogService {
  private readonly dialog = inject(MatDialog);
  private readonly overlay = inject(Overlay);

  async openInviteDialog(
    entityType: EntityIdAliasPrefixes,
    id: string,
  ): Promise<MatDialogRef<ShareDialog, null>> {
    const module =
      await import('../components/share-dialog/share-dialog.component');

    return this.dialog.open<ShareDialog, ShareDialogData, null>(
      module.ShareDialog,
      {
        width: DEFAULT_DIALOG_WIDTH,
        data: {
          type: ShareDialogType.INVITE,
          entityType,
          id,
          people: [],
        },
        panelClass: ['share-dialog', 'invite-dialog'],
        scrollStrategy: this.overlay.scrollStrategies.block(),
      },
    );
  }

  async openNotifyDialog(
    entityType: EntityIdAliasPrefixes,
    id: string,
    people: (UserModel | null)[],
  ): Promise<MatDialogRef<ShareDialog, null>> {
    const module =
      await import('../components/share-dialog/share-dialog.component');

    return this.dialog.open<ShareDialog, ShareDialogData, null>(
      module.ShareDialog,
      {
        width: DEFAULT_DIALOG_WIDTH,
        data: {
          type: ShareDialogType.NOTIFY,
          entityType,
          id,
          people,
        },
        panelClass: ['share-dialog', 'notify-dialog'],
        scrollStrategy: this.overlay.scrollStrategies.block(),
      },
    );
  }

  async openInvitedUsersDialog(
    users: InvitedUserModel[],
    entityType: EntityIdAliasPrefixes,
    id: string,
    canRemove: boolean,
    onRemove: () => void,
  ): Promise<MatDialogRef<InvitedUsersDialog, InvitedUserModel[]>> {
    const module =
      await import('../components/invited-users-dialog/invited-users-dialog.component');

    return this.dialog.open<
      InvitedUsersDialog,
      InvitedUsersDialogData,
      InvitedUserModel[]
    >(module.InvitedUsersDialog, {
      width: DEFAULT_DIALOG_WIDTH,
      data: {
        users,
        entityType,
        id,
        canRemove,
        onRemove,
      },
      panelClass: ['invited-users-dialog'],
      scrollStrategy: this.overlay.scrollStrategies.block(),
    });
  }
}
